import { render } from "./Text.vue?vue&type=template&id=4606e4ac&ts=true"
import script from "./Text.vue?vue&type=script&lang=ts"
export * from "./Text.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__